import { Article } from "../gateways/cms/article";
import { ScheduleArticleMenu } from "../components/ScheduleArticleMenu";
import { PeriodBar } from "../components/PeriodBar";
import Chip from "@mui/material/Chip";
import { Container, Draggable, DropResult } from "react-smooth-dnd";

import { styled } from "@mui/system";
import Tooltip from '@mui/material/Tooltip';
import VarConst from "../styles/variables.js";
import iconEllipsis from "../assets/icons/icon_ellipsis.svg";
import iconEllipsisInvalid from "../assets/icons/icon_ellipsis_invalid.svg";
import { articleStatusNames } from "../gateways/cms/article";
import produce from "immer";
import { useLayoutEffect, useState, ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectOrderedArticles, setOrderedArticles } from "../features/cms/orderedArticlesSlice";
import { ImageModal } from "./materials/ImageModal";
import { getTotalDuration } from "../features/shared/articleDuration";
import Stack from "@mui/material/Stack";
import ButtonMUI from "@mui/material/Button";
import { useBulkUpdateArticleStatusMutation } from "../gateways/cms/articleApi";
import { confirmWithStyle } from "../components/MyConfirm";
import { ArticleStatus } from "../gateways/cms/article";

import iconCheckboxOff from "../assets/icons/icon_checkbox_off.svg";
import iconCheckboxOn from "../assets/icons/icon_checkbox_on.svg";
import icon_checkbox_disabled from "../assets/icons/icon_checkbox_disabled.svg";

// style
const varCss = {
    scHeaderH: "48px",
    scItemH: "135px",
    border1: "#dadce0 1px solid",
    periodHeaderW: "460px",
    chkboxSize: "24px",
};
const ScheduleList = styled("section")`
    display: flex;
    height: 100%;
    padding: 0 24px;
    overflow: hidden;
    background-color: #fff;

    .scheduleWrapper {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: hidden;
        flex: 1;
    }

    /* 期間単位の幅を指定 */
    .periodCell {
        /* min-width: 48px; */
        flex: 1;

        &:last-child {
            flex: unset;
            width: 0;
        }
    }
    .checkboxAll {
        input[type="checkbox"] {
            position: absolute;
            opacity: 0;
            cursor: pointer;

            & + span::before {
                content: "";
                display: block;
                margin: 0px 12px 0px 8px;
                width: 18px;
                height: 18px;
                pointer-events: none;
                background: transparent url(${iconCheckboxOff}) scroll no-repeat center center;
            }
            &:checked + span::before {
                background-image: url(${iconCheckboxOn});
            }
            &:disabled + span::before {
                background: transparent url(${icon_checkbox_disabled}) scroll no-repeat center center;
            }
        }
    }

    /* スケジュール 日付ヘッダ */
    .scheduleHeader {
        height: auto;
        width: 99%;

        .scheduleHeaderInner {
            display: flex;
            position: relative;
            background-color: #fff;
            box-sizing: border-box;
            margin-left: auto;
            padding-left: ${varCss.periodHeaderW};

            .periodCell {
                /* height: ${varCss.scHeaderH}; */
            }
            /* 時刻表示 */
            .dateTime {
                text-align: center;
                display: block;
                position: relative;
                top: 100%;
                width: 3em;
                transform: translate(-50%, -100%);
            }
        }
    }

    /* スケジュール 本体 */
    .scheduleBody {
        display: flex;
        align-items: flex-start;
        /* overflow-x: hidden; */
        overflow-y: auto;
        /* overflow: auto; */
        width: 100%;
        border-bottom: ${varCss.border1};
        border-left: ${varCss.border1};

        .scheduleBodyInner {
            min-width: 100%;
            flex: none;
            vertical-align: top;

            overflow: hidden;
            position: relative;
            margin-bottom: -1px;
            margin-left: -1px;
        }

        /* グリッド */
        .scheduleGrid {
            display: flex;
            padding-left: ${varCss.periodHeaderW};
            border-top: ${varCss.border1};

            position: absolute;
            width: 100%;
            height: 100%;

            .periodCell {
                &::after {
                    content: "";
                    display: block;
                    position: relative;
                    z-index: 0; // 初期値 3
                    height: 100%;
                    margin-left: -1px;
                    border-left: ${varCss.border1};
                    border-width: 2px;
                    pointer-events: none;
                }
                &:nth-of-type(n + 0):nth-of-type(-n + 6),
                &:nth-of-type(n + 19):nth-of-type(-n + 25) {
                    &::after {
                        /* width: 100%; */
                        background-color: #f0f9ff80;
                    }
                }
                /* &:nth-of-type(n+7):nth-of-type(-n+19) {
                        &::after {
                            border-color: #C3D3EA;
                        }
                    } */
            }
        }
    }

    /*  左端 コンテンツ概要 見出し  */
    .articleSummary {
        position: relative;
        z-index: 1;
        height: ${varCss.scItemH};
        min-height: ${varCss.scItemH};
        width: ${varCss.periodHeaderW};
        overflow: hidden;
        box-sizing: border-box;
        background-color: white;
        border-right: ${varCss.border1};

        &::after {
            content: "";
            position: absolute;
            display: block;
            width: 100%;
            bottom: 0;
            left: 0;
            border-bottom: ${varCss.border1};
        }

        ul {
            width: 100%;
            height: 100%;
            padding: 6px 8px 6px 8px;
            display: grid;
            grid-template-rows: 25% 15% 14% 14% 20% 1fr;
            grid-template-columns: 4% 28% 20% 20% 3% 1fr;

            .type {
                grid-row: 1/2;
                grid-column: 3/5;
            }
            .id {
                grid-row: 1/2;
                grid-column: 6/7;
            }
            .title {
                grid-row: 2/3;
                grid-column: 3/7;
                white-space: nowrap;
                overflow: hidden;
                &:hover{
                    overflow: visible;
                    text-overflow: "";
                }
            }
            .period {
                grid-row: 3/4;
                grid-column: 3/7;
            }
            .week {
                grid-row: 4/5;
                grid-column: 3/7;
            }
            .day {
                grid-row: 5/6;
                grid-column: 3/7;
            }
            .at_least {
                grid-row: 1/2;
                grid-column: 3/5;
            }
            .at_least_minimum {
                grid-row: 1/2;
                grid-column: 3/5;
            }
            .owner {
                grid-row: 6/7;
                grid-column: 3/6;
            }
            .updater {
                grid-row: 6/7;
                grid-column: 6/7;
            }
            .thumbnail {
                grid-row: 1/7;
                grid-column: 2/3;
            }
            .checkbox {
                grid-row: 1/7;
                grid-column: 1/2;
            }

            .id,
            .type,
            .period,
            .week,
            .day,
            .owner,
            .updater,
            .at_least {
                font-size: 12px;
                letter-spacing: 0;
            }
            .at_least_minimum {
                font-size: 12px;
                letter-spacing: 0;
            }
            .id {
                letter-spacing: 0;
                text-indent: 0.75em;
            }
            .title {
                * {
                    margin: 0;
                    font-size: 13px;
                    font-weight: normal;
                }
            }
            .period {
                letter-spacing: 0;
            }
            .week {
                letter-spacing: 0;
            }
            .day {
                letter-spacing: 0;
                padding-left:4.7em;
	            text-indent:-4.7em;
                line-height: 1.1em;
            }
            .at_least {
                text-align: right;
                .MuiChip-root {
                    height: unset;
                    background-color: #9290e1;
                }
            }
            .at_least_minimum {
                text-align: right;
                .MuiChip-root {
                    height: unset;
                    background-color: #22b14c;
                }
            }
            .thumbnail {
                text-align: center;

                img {
                    width: auto;
                    height: auto;
                    max-width: 104px;
                    max-height: 104px;
                }
                label.duration {
                    display: block;
                    margin-top: 2px;
                    font-size: 11px;
                    color: #788189;
                }
            }
            .checkbox {
                input[type="checkbox"] {
                    position: absolute;
                    margin: 5px 1px;
                    width: 18px;
                    height: 18px;
                    z-index: 1;
                    opacity: 0;
                    cursor: pointer;

                    & + span::before {
                        content: "";
                        display: block;
                        width: 18px;
                        height: 18px;
                        pointer-events: none;
                        background: transparent url(${iconCheckboxOff}) scroll no-repeat center center;
                    }
                    &:checked + span::before {
                        background-image: url(${iconCheckboxOn});
                    }
                    &:disabled + span::before {
                        background: transparent url(${icon_checkbox_disabled}) scroll no-repeat center center;
                    }
                }
            }
        }
        ul + div {
            position: absolute;
            top: 8px;
            right: 8px;

            & > button {
                height: 24px;
                width: 24px;
                min-width: 24px;
                border: ${VarConst.border1};
                border-width: 2px;
                border-radius: 2px;
                background-image: url(${iconEllipsis});
                background-repeat: no-repeat;
                background-position: center center;
                background-color: #fff;
            }

            /* POP部分 */
            ul {
                border-radius: 2px;
                padding: 0;

                li {
                    border: ${VarConst.border1};
                }
            }
        }
    }

    /* スケジュール横列 範囲 */
    .scheduleGridCell {
        position: relative;
        flex: 1 1 auto;
        height: ${varCss.scItemH};
        min-height: ${varCss.scItemH};
        margin-bottom: -1px;
        box-sizing: border-box;
        border: ${varCss.border1};

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            display: block;
            width: 100%;
            height: 100%;
            background-color: transparent;
            mix-blend-mode: darken;
        }

        // export const articleStatusNames = ["下書き", "確認中", "差戻", "掲載待ち", "掲載中", "掲載終了", "一時停止中", "削除"];
        // export const articleStatusNames = [status0, status1, status2, status3, status4, status5, status6, status7];

        &.status0,
        &.draft {
            &::after {
                background-color: #f5f5f5;
            }
            .articleSummary {
                background-color: #f5f5f5;
            }
            .periodBar {
                background-color: #c9d9ee;
                border-color: #c9d9ee;
            }
        }

        .periodRail {
            position: relative;
            top: -100%;
            height: 100%;
            /* width: 100%; */
            margin-left: ${varCss.periodHeaderW};
        }

        /* スケジュール 棒グラフ 掲載 */
        .periodBar {
            position: absolute;
            top: 50%;
            z-index: 5;
            height: 32px;
            outline: none;
            color: #fff;
            line-height: 32px;
            text-align: center;
            background-color: #72a1e2;
            border-color: #72a1e2;
            border-radius: 2px;
            transform: translate(0, -50%);
            /* 開始位置と長さは動的に与える(仮の値) */
            left: 0;
            width: 20%;

            h4 {
                margin: 0;
                display: none;
            }
        }
        /* スケジュール 棒グラフ 一時停止 */
        .periodBarSuspend {
            position: absolute;
            top: 50%;
            z-index: 5;
            height: 32px;
            outline: none;
            color: #fff;
            line-height: 32px;
            text-align: center;
            background-color: #7f7f7f;
            border-color: #7f7f7f;
            border-radius: 2px;
            transform: translate(0, -50%);
            /* 開始位置と長さは動的に与える(仮の値) */
            left: 0;
            width: 20%;

            h4 {
                margin: 0;
                display: none;
            }
        }
        /* スケジュール 棒グラフ 掲載・一時停止 以外*/
        .periodBarError {
            position: absolute;
            top: 50%;
            z-index: 5;
            height: 32px;
            outline: none;
            color: #fff;
            line-height: 32px;
            text-align: center;
            background-color: #dd8b6eff;
            border-color: #dd8b6eff;
            border-radius: 2px;
            transform: translate(0, -50%);
            /* 開始位置と長さは動的に与える(仮の値) */
            left: 0;
            width: 20%;

            h4 {
                margin: 0;
                display: none;
            }
        }
    }
    .menuButton{
        height: 24px;
        width: 24px;
        min-width: 24px;
        border: 2px solid #C9CBD3;
        border-radius: 2px;
        background-image: url(${iconEllipsisInvalid});
        background-repeat: no-repeat;
        background-position: center center;
        background-color: #fff;
        background-size: 80%;
    }
`;
const BarList = styled("section")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;

    [class$="MuiStack-root"] {
        align-items: center;

        & > :not(style) + :not(style) {
            margin-left: 16px;
        }
    }
`;
const ButtonArticle = styled(ButtonMUI)`
    height: 25px;
    border-radius: 2px;
`;

export interface Props {
    deliveryGroupId: number;
    date: string; // 2022-02-01
    onArticleDuplicate: (id: number, modaloption: string, deliveryGroupId: number, orderManagement: boolean) => void;
    onArticleSuspend: (article: Article, suspended: boolean, deliveryGroupId: number, startDate: string) => void;
    articles: any;
    checkAgent: boolean;
    orderManagement?: boolean;
}

export const DailySchedule = ({
    deliveryGroupId,
    date,
    onArticleDuplicate,
    onArticleSuspend,
    articles,
    checkAgent,
    orderManagement = false,
    
}: Props) => {
    const dispatch = useDispatch();
    const articleDatas: Article[] = articles.data;
    const orderedArticles = useSelector(selectOrderedArticles);

    // あんま良くない方法だけどとりあえず保存ボタンを外に置くためにこの実装で
    useLayoutEffect(() => {
        if (articleDatas) {
            dispatch(setOrderedArticles(articleDatas));
            setDragging(false);
        } else {
            dispatch(setOrderedArticles([]));
        }
    }, [articleDatas, dispatch]);

    const [dragging, setDragging] = useState(false);
    const handleDrop = ({ removedIndex, addedIndex }: DropResult) => {
        if (removedIndex === null || addedIndex === null) {
            return;
        }
        const dropArticles= produce(orderedArticles, (draft) => {
            const t = draft.splice(removedIndex, 1);
            draft.splice(addedIndex, 0, ...t);
        });
        dispatch(setOrderedArticles(dropArticles));
        setDragging(true);
    };

    const [selectedArticles, setSelectedArticles] = useState<number[]>([]);
    const handleSelect = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setSelectedArticles([...selectedArticles, Number(e.target.value)]);
        } else {
            setSelectedArticles(selectedArticles.filter((id) => id !== Number(e.target.value)));
        }
        
    };
    const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
        if (!articles.data) {
            return;
        }
        let selectArticles: number[] = [];
        if (e.target.checked) {
            articles.data?.forEach((article: Article) => {
                selectArticles.push(Number(article.id)); 
            });
            setSelectedArticles(selectArticles);
        } else {
            setSelectedArticles([]);
        }
    };

    const [articleBulkUpdateStatus] = useBulkUpdateArticleStatusMutation();
    const handleArticleMakeSuspend = async () => {
        let bodyText = "選択したコンテンツを一時停止にします。\nよろしいですか？";
        if(getArticleMinimumType()){
            bodyText = "選択したコンテンツを一時停止にします。\n回数保証コンテンツも含みます。\nよろしいですか？";
        }
        const isConfirmed = await confirmWithStyle({
            title: "掲載を一時停止",
            body: bodyText,
            okButtonText: "一時停止",
        });
        if (isConfirmed) {
            articleBulkUpdateStatus({ 
                status: ArticleStatus.SUSPENDED, 
                articleIds: selectedArticles,
                deliveryGroupId: deliveryGroupId,
                startDate: date,
                ...(orderManagement !== undefined && { orderManagement }),
            });
        }
    };
    const handleArticleMakePublish = async () => {
        let bodyText = "選択したコンテンツの一時停止を解除して掲載します。\nよろしいですか？";
        if(getArticleMinimumType()){
            bodyText = "選択したコンテンツの一時停止を解除して掲載します。\n回数保証コンテンツも含みます。\nよろしいですか？";
        }
        const isConfirmed = await confirmWithStyle({
            title: "一時停止を解除",
            body: bodyText,
            okButtonText: "掲載",
        });
        if (isConfirmed) {
            articleBulkUpdateStatus({ 
                status: ArticleStatus.PUBLISHED, 
                articleIds: selectedArticles,
                deliveryGroupId: deliveryGroupId,
                startDate: date,
                ...(orderManagement !== undefined && { orderManagement }),
            });
        }
    };

    const getArticleMinimumType = ():Boolean => {
        let ret = false;
        articleDatas.forEach((article) => {
            if(article.content.type === "minimum-schema" &&
                selectedArticles.includes(article.id)){
                    ret = true;
            }
        })
        return ret;
    };

    const getArticleContentType = (type: String):String => {
        if (type === "minimum-schema") {
            return '回数保証コンテンツ';
        }
        else {
            return '通常コンテンツ';
        }
    };

    const getContentTypeClass = (type: String):string => {
        if (type === "minimum-schema") return 'at_least_minimum';
        else return 'at_least';
    };

    const getPeriodWeek = (periodWeek: number[]):String => {
        let check = false;
        let week = ["日","月","火","水","木","金","土"];
        let period = "曜日指定 : ";

        for(let i = 0; i < 7; i++){
            if(periodWeek[i] === 1){
                if(!check) check = true;
                period += week[i]+" ";
            }
        }
        if(!check) period = "";
        return period;
    };
 
    const getPeriodDay = (periodDay: number[] | null):String => {
        let period = "日付指定 : ";
        if(periodDay){
            // 毎日の場合
            if(periodDay.length === 31){period += "毎日掲載";}
            // 毎日でない場合
            else{
                for(let i = 0; i < periodDay.length; i++){
                    period += periodDay[i]+" ";
                }
            }
        }
        else{
            period = "";
        }
        return period;
    };

    const unAuthTooltip = (dragging:boolean, checkAgent:boolean):string => {
        if(checkAgent) return "広告代理店ユーザーは編集できません";
        if(dragging) return "掲載順移動中は編集できません";
        return "広告代理店ユーザーまたは掲載順移動中は編集できません"
    }

    const checkContentType = (article: Article):boolean => {
        if (article.content && article.content.type && article.content.type === "minimum-schema")
            return true;
        else return false;
    };

    return (
        <ScheduleList>
            <div className="scheduleWrapper">
                <BarList>
                    <div className="checkboxAll">
                        <input
                            type="checkbox"
                            onChange={handleSelectAll}
                        />
                        <span></span>
                    </div>
                    <Stack spacing={1} direction="row">
                        <ButtonArticle type="button" onClick={handleArticleMakeSuspend}>
                            {/* まとめて  */}選択コンテンツ一時停止
                        </ButtonArticle>
                        <ButtonArticle type="button" onClick={handleArticleMakePublish}>
                            {/* まとめて */}選択コンテンツ一時停止解除
                        </ButtonArticle>
                    </Stack>
                </BarList>
                {/* <!-- ## ヘッダ表示 --> */}
                <div className="scheduleHeader">
                    <div className="scheduleHeaderInner">
                        {(() => {
                            const cells = [];
                            let GridCells = 24;
                            for (let i = 0; i <= GridCells; i++) {
                                cells.push(
                                    <div className={`periodCell cell${i}`}>
                                        {" "}
                                        <span className="dateTime"> {i} </span>{" "}
                                    </div>
                                );
                            }
                            return <>{cells}</>;
                        })()}
                    </div>
                </div>

                {/* <!-- ## 予定表示 --> */}
                <div className="scheduleBody">
                    <div className="scheduleBodyInner">
                        <div className="scheduleGrid">
                            {(() => {
                                const cells = [];
                                let GridCells = 24;
                                for (let i = 0; i <= GridCells; i++) {
                                    cells.push(<div className={`periodCell cell${i}`}></div>);
                                }
                                return <>{cells}</>;
                            })()}
                        </div>

                        <Container lockAxis="y" onDrop={handleDrop}>
                            {orderedArticles.map((article) => (
                                <Draggable
                                    className={`DeliveryArticleItem scheduleGridCell status${articleStatusNames.indexOf(
                                        article.status.toString()
                                    )}`}
                                    schedule-id={article.id}
                                    key={article.id}
                                >
                                    <div className="articleSummary" style={{ backgroundColor: article.backgroundColor, color: article.labelColor}}>
                                        <ul>
                                            <li className="title">
                                                <h2>{article.title}</h2>
                                            </li>
                                            <li className="id">ID: {article.id}</li>
                                            <li className="type">{article.schemaGroupId}</li>
                                            <li className="period">
                                                {article.periodDayStart.replace(/-/g, "/").slice(0, -3)} 〜{" "}
                                                {article.periodDayEnd?.replace(/-/g, "/").slice(0, -3) || "無期限"}
                                            </li>
                                            <li className="week">
                                                {getPeriodWeek(article.periodWeek)}
                                            </li>
                                            <li className="day">
                                                {getPeriodDay(article.periodDay)}
                                            </li>
                                            <li className={getContentTypeClass(article.content.type)}>
                                                {article.content.type && (
                                                    <Chip
                                                        label={`${getArticleContentType(article.content.type)}`}
                                                        color="primary"
                                                        size="small"
                                                    />
                                                )}
                                            </li>
                                            <li className="owner">コンテンツ所有者: {article.createdBy.name}</li>
                                            {/*<li className="updater">掲載更新者: {article.updatedBy?.name}</li>*/}
                                            <li className="thumbnail">
                                                {article.thumbnailType === 'image' ?
                                                    <ImageModal
                                                        imageUrl={`${article.thumbnailData}`}
                                                        imageAlt={`${article.title}`}
                                                    >
                                                        <img
                                                            src={`${article.thumbnail}`}
                                                            alt={`${article.title}`}
                                                        />
                                                    </ImageModal>
                                                    :
                                                    <a href={`${article.thumbnailData}`} target="_blank" rel="noreferrer">
                                                        <img src={`${article.thumbnail}`} alt={`${article.title}`}></img>
                                                    </a>
                                                }
                                                {getTotalDuration(article.articleSchema) > 0 && (
                                                    <label className="duration">{getTotalDuration(article.articleSchema)}秒</label>
                                                )}
                                            </li>
                                            <li className="checkbox">
                                                <input
                                                    type="checkbox"
                                                    value={article.id}
                                                    checked={selectedArticles.includes(article.id)}
                                                    disabled={checkContentType(article)}
                                                    onChange={handleSelect}
                                                /><span></span>
                                            </li>
                                        </ul>

                                        { (dragging === false && !checkAgent)
                                            ? <ScheduleArticleMenu
                                                article={article}
                                                deliveryGroupId={deliveryGroupId}
                                                startDate={date}
                                                onArticleDuplicate={onArticleDuplicate}
                                                onArticleSuspend={onArticleSuspend}
                                                orderManagement={orderManagement}
                                              />
                                            : <Tooltip title={unAuthTooltip(dragging, checkAgent)} arrow>
                                                <div className="menuButton" />
                                              </Tooltip>
                                        }
                                        {/*
                                        <Link to={`/articles/${article.id}/edit`}>詳細情報</Link>
                                        <button onClick={() => onArticleDuplicate(article.id)}>コピー</button>
                                        {/* <button onClick={() => onArticleSuspend(article, true)}>掲載を一時停止</button> * /}
                                        <button onClick={() => onArticleSuspend(article, false)}>掲載</button>
                                        */}
                                    </div>

                                    <div className="periodRail">
                                        <PeriodBar article={article} date={date} />
                                    </div>
                                </Draggable>
                            ))}
                        </Container>
                    </div>
                </div>
            </div>
        </ScheduleList>
    );
};
